import i18n from "i18next";
import AdminEvalPassDetail from "./AdminEvalPassDetail";
import * as React from "react";
import { AdminEvalStudy } from "../../api/EvalStudyAdminApi";

export function getAuthors(evalStudy: AdminEvalStudy) {
  return evalStudy.passes.flatMap((pass) => pass.author);
}

type AdminEvalStudiesPanelProps = {
  evalStudies: AdminEvalStudy[];
  authorIdsToDisplay: string[];
  onAuthorsChanged: (authorIds: string[]) => void;
};

export function AdminEvalStudiesPanel({
  evalStudies = [],
  authorIdsToDisplay = [],
  onAuthorsChanged,
}: AdminEvalStudiesPanelProps) {
  const handlePassAuthorsToDisplayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAuthorIds = (Array.apply(null, e.target.options) as HTMLOptionElement[])
      .filter((option) => option.selected)
      .map((option) => option.value);

    onAuthorsChanged(selectedAuthorIds);
  };

  const rowsCount =
    evalStudies.length +
    evalStudies
      .map((evalStudy) => {
        let nbAuthorIdsInEvalStudy = new Set(evalStudy.passes.flatMap((pass) => pass.author)).size;
        return nbAuthorIdsInEvalStudy;
      })
      .reduce((prevAuthorsSize, currentAuthorsSize) => prevAuthorsSize + currentAuthorsSize, 0);

  const minRows = Math.min(rowsCount, 12);

  return (
    <div className="card">
      <div className="card-title">{i18n.t("global.evalStudies")}</div>
      {evalStudies.length > 0 && (
        <div className="card-body">
          <div className="form-row">
            <div className="col-form-label col-3">{i18n.t("global.authors")}</div>

            <select
              className="form-control col-9 overflow-y-auto"
              id="selectAuthorsToDisplay"
              value={authorIdsToDisplay}
              multiple
              size={minRows}
              onChange={handlePassAuthorsToDisplayChange}
            >
              {evalStudies.map((evalStudy) => (
                <optgroup key={evalStudy.id} label={i18n.t("global.evalStudy") + " " + evalStudy.id}>
                  {[...new Set(getAuthors(evalStudy))].map((author) => (
                    <option key={author} value={author}>
                      {author}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>

          {evalStudies.map((evalStudy) => (
            <div key={evalStudy.id} className="card">
              <div className="card-title">
                {i18n.t("global.evalStudy")} {evalStudy.id}
              </div>
              <div className="card-body">
                <div>
                  {i18n.t("global.evalCode")} : {evalStudy.evalCode}{" "}
                </div>
                <div>
                  {i18n.t("global.step")} : {evalStudy.step}
                </div>
                {evalStudy.passes.map((pass, passIdx) => (
                  <AdminEvalPassDetail key={passIdx} pass={pass} passIdx={passIdx} />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
